import { useState, useEffect, createContext } from 'react';
import { toast } from 'react-toastify';
import { USER } from '../services/routes';
import axios from 'axios';

export const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLogged, setIsLogged] = useState(false);
    const [loadingAuth, setLoadingAuth] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let token = localStorage.getItem("token")
        let userId = localStorage.getItem("userId")
        if (token && userId) {
            axios.get(`${USER.AUTH.replace(/:id/gi, userId)}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((json) => {
                console.clear()
                saveUserGet(json)
                console.log(json)
                setLoading(false)
            })
                .catch((err) => {
                    console.log(err)
                    logout()
                })
        }
    }, [isLogged])

    const saveUserGet = ({ data }) => {
        setUser(data.user);
        // console.log('saveUserGet ', data.user)
        setIsLogged(true)
    }

    const saveUserLogged = ({ data }, token = true) => {
        logout();
        if (token) setUser(data)
        setIsLogged(true)
    }

    const login = async (email, password) => {
        setLoadingAuth(true)
        try {
            let data = await axios.post(USER.LOGIN, {
                email,
                password
            })
            toast.success('Bem vindo de volta!')
            saveUserLogged(data)
            console.log(data)
            localStorage.setItem("userId", data.data.data.user._id)
            localStorage.setItem("token", data.data.data.token)
        }
        catch (error) {
            console.log(error)
            setLoadingAuth(false)
            toast.error('E-mail ou senha incorretos.')
        }

    }

    const logout = () => {
        localStorage.removeItem('token')
        setUser(null)
        setLoadingAuth(false)
    }


    return (

        < AuthContext.Provider
            value={{
                signed: !!user,
                login,
                isLogged,
                user,
                logout,
                loadingAuth
            }}
        >
            {children}
        </AuthContext.Provider >
    )
}
export default AuthProvider
